import { Check, Columns3 } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

// 「表示列」ボタン＋ドロップダウン（発注照合テーブルの実装を切り出した共通部品）。
// 開閉 state はこのコンポーネント内部に閉じ、呼び出し側は表示中/非表示の集合だけを管理する
export function TableColumnMenu({
  columns,
  hidden,
  onToggle,
}: {
  columns: ReadonlyArray<{ key: string; label: string }>
  hidden: ReadonlySet<string>
  onToggle: (key: string) => void
}) {
  const [colMenuOpen, setColMenuOpen] = useState(false)
  const visibleCount = columns.filter((col) => !hidden.has(col.key)).length

  return (
    <div className="relative ml-auto">
      <Button
        variant="outline"
        size="sm"
        className="gap-1.5"
        aria-expanded={colMenuOpen}
        onClick={() => {
          setColMenuOpen((v) => !v)
        }}
      >
        <Columns3 className="size-3.5" />
        表示列
        {hidden.size > 0 && (
          <span className="inline-flex min-w-5 items-center justify-center rounded-full bg-muted px-1.5 text-xs font-medium text-muted-foreground">
            {visibleCount}/{columns.length}
          </span>
        )}
      </Button>
      {colMenuOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            aria-hidden="true"
            onClick={() => {
              setColMenuOpen(false)
            }}
          />
          <div className="absolute right-0 top-full z-20 mt-1 max-h-80 w-60 overflow-y-auto rounded-lg border border-border bg-popover p-1 shadow-lg">
            <p className="px-2 py-1.5 text-xs font-medium text-muted-foreground">表示する列を選択</p>
            {columns.map((col) => {
              const isVisible = !hidden.has(col.key)
              return (
                <button
                  key={col.key}
                  type="button"
                  onClick={() => {
                    onToggle(col.key)
                  }}
                  className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm text-foreground hover:bg-muted"
                >
                  <span
                    className={cn(
                      'flex size-4 items-center justify-center rounded border',
                      isVisible ? 'border-primary bg-primary text-primary-foreground' : 'border-input bg-card',
                    )}
                  >
                    {isVisible && <Check className="size-3" strokeWidth={3} />}
                  </span>
                  {col.label}
                </button>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}
